<template>
  <div id="app">
    <Home/>
  </div>
</template>

<script>
import Home from './components/Home.vue'

export default {
  name: 'app',
  components: {
    Home
  }
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Lato:400,700');
  html, body { font-family: 'Lato', sans-serif !important; height: 100% !important; background-color: #000 !important; }
  body { display: -ms-flexbox !important; display: flex !important; color: #fff !important; text-shadow: 0 .05rem .1rem rgba(0, 0, 0, .5); box-shadow: inset 0 0 5rem rgba(0, 0, 0, .5); }
  #app {
    width: 100%;
    height: 100%;
  }
</style>
